import { popOverContainerStyle } from '@/components/Popover';
import TextField from '@/components/TextField/TextField';
import { StyledSlider as StyledSliderTemplate } from '@/pages/AdvancedEditor/components/panels/common/StyledSlider';
import theme from '@/theme';
import styled from '@emotion/styled';

export const MultiLineInput = styled(TextField)<{ textTooLong?: boolean }>`
    width: 100%;

    & .MuiFormHelperText-root {
        margin: unset;
        color: ${theme.colors.secondary[400]};
    }

    & .Mui-error.Mui-focused fieldset {
        border-color: ${({ theme, textTooLong }) => textTooLong && theme.colors.error.main} !important;
    }

    textarea {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0.15px;
    }
`;

export const CharCounterContainer = styled.div<{ textTooLong?: boolean }>`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    color: ${({ textTooLong, theme }) => (textTooLong ? theme.colors.error.main : theme.colors.black[700])};
    margin-inline: auto;
    margin-top: 4px;
    width: 99%;
`;

export const StyledSlider = styled(StyledSliderTemplate)`
    .MuiSlider-valueLabel {
        ${popOverContainerStyle}
    }

    :not(.Mui-disabled) {
        .MuiSlider-rail {
            color: ${({ theme }) => theme.colors.secondary[400]};
        }
    }
`;

export const StyledTextField = styled(TextField)`
    margin: 0;
    & .MuiInputBase-root {
        box-sizing: content-box;
        padding-block: 8px;

        height: 24px;
        border-radius: 8px;

        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        letter-spacing: 0.15px;
        line-height: 16px;

        color: ${theme.colors.secondary.main};
    }
`;
